export default process.env.REACT_APP_N8N_SURVEY_ENDPOINT as string
